<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-back-wrapper">
                <div class="page-back" @click="handleBack">
                    <img src="@/assets/img/back.png" alt="" class="page-back-img">
                    <span>返回</span>
                </div>
            </div>

            <div class="page-content-container">
                <div class="page-content-header page-branch">
                    <div class="page-header-block"></div>
                    <div class="page-content-header-item-active">课程信息</div>
                </div>
                <div class="page-card-wrapper">
                    <div class="course-info-item">
                        课程名称：{{ courseDetail.courseName }}
                    </div>
                    <div class="course-info-item">
                        课程总时长：{{ courseDetail.videoTotalTime }}分钟
                    </div>
                    <div class="course-info-item">
                        讲师：{{ courseDetail.teacherName }}
                    </div>
                </div>
            </div>

            <div class="page-content-container">
                <div class="page-content-header page-branch">
                    <div class="page-header-block"></div>
                    <div class="page-study-header-item-active">
                        课程学习统计
                    </div>
                    <el-popover placement="top-start" title="注解：" width="360" trigger="hover">
                        <div class="popover-label">
                            <div>已观看人数：已观看人数/可观看该课程的总人数</div>
                            <div>未观看人数：未观看人数/可观看该课程的总人数</div>
                            <div>进度100%人数：观看该课程达到100%进度的总人数</div>
                        </div>
                        <img src="@/assets/img/study.png" alt="" class="study-image" slot="reference">
                    </el-popover>
                </div>
                <div class="page-menmber-container member-card-container">
                    <div class="page-menmber-wrapper">
                        <div class="card-container">
                            <div class="card-item">
                                <div class="card-image-wrapper">
                                    <img src="@/assets/img/statistical1.png" alt="" class="card-img">
                                </div>
                                <div class="card-content">
                                    <div class="card-title">已观看人数</div>
                                    <div class="card-data">
                                        <IOdometer class="iOdometer" :value="cardData.alreadyView" />/
                                        <IOdometer class="iOdometer" :value="cardData.totalView" />人
                                    </div>
                                </div>
                            </div>
                            <div class="card-item">
                                <div class="card-image-wrapper">
                                    <img src="@/assets/img/statistical2.png" alt="" class="card-img">
                                </div>
                                <div class="card-content">
                                    <div class="card-title">未观看人数</div>
                                    <div class="card-data">
                                        <IOdometer class="iOdometer" :value="cardData.notView" />/
                                        <IOdometer class="iOdometer" :value="cardData.totalView" />人
                                    </div>
                                </div>
                            </div>
                            <div class="card-item">
                                <div class="card-image-wrapper">
                                    <img src="@/assets/img/statistical3.png" alt="" class="card-img">
                                </div>
                                <div class="card-content">
                                    <div class="card-title">进度100%人数</div>
                                    <div class="card-data">
                                        <IOdometer class="iOdometer" :value="cardData.finishedView" />人
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-content-container">
                <div class="page-content-header page-branch">
                    <div class="page-header-block"></div>
                    <div class="page-content-header-item-active">学习成员</div>
                </div>
                <div class="page-menmber-container">
                    <div class="page-menmber-wrapper">
                        <div class="page-mode-input-wrapper">
                            <div class="page-mode-input">
                                <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
                            </div>
                            <div class="input-btn" @click="handleSearch">
                                <i class="el-icon-search input-btn-icon"></i>
                                <span class="input-btn-label">搜索</span>
                            </div>
                        </div>
                        <List :mode="listMode" :tableData="tableData"></List>
                        <div v-if="tableData.length > 0 && currentPage < totalPages" class="view-more-btn" @click="viewMore">
                            查看更多</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCourseDetailStatistics, getCourseRecordMemberList } from '@/api/index.js';
import Header from '@/components/Header.vue'
import List from '@/components/List.vue'
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
export default {
    name: '',
    components: {
        Header,
        List,
        IOdometer
    },
    data() {
        return {
            dept: '',
            token: "",
            listMode: "study-course-report-detail",
            searchVal: "",
            courseDetail: {},
            cardData: {
                alreadyView: 0,
                totalView: 0,
                notView: 0,
                finishedView: 0
            },
            tableData: [],
            currentPage: 1,
            totalPages: 1
        }
    },
    created() {
        scrollTo(0, 0);
        // this.dept = this.$route.params.dept;
        // this.token = window.localStorage.getItem('token');
           this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
    },
    mounted() {
        this.statisticsData();
        this.getMemberList();
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
            //  this.$router.push(`/index/study-report-course/${this.dept}/${this.token}`);
        },
        statisticsData() {
            var courseid = this.$route.params.id;
            getCourseDetailStatistics(courseid, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.courseDetail = data;
                    this.cardInit();
                }
                return;
            }).catch(err => {
               // console.log(err);
            });
        },
        cardInit() {
            this.$nextTick(function () {
                var alreadyView = this.courseDetail.watchUserCount;
                var totalView = this.courseDetail.totalUserCount;
                var notView = totalView - alreadyView;
                this.cardData = {
                    alreadyView: alreadyView,
                    totalView: totalView,
                    notView: notView,
                    finishedView: this.courseDetail.finishedUserCount
                }
            });
        },
        getMemberList() {
            var courseid = this.$route.params.id;
            getCourseRecordMemberList({
                "deptId": 0,
                "keyword": this.searchVal,
                "pageNum": this.currentPage,
                "pageSize": 10,
                "recordId": courseid,
                "sortDirect": "desc",
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.totalPages = data.totalPages;
                    var dataArr = this.tableData;
                    this.tableData = dataArr.concat(data.list);
                }
                return;
            }).catch(err => {
               // console.log(err);
            });
        },
        handleSearch() {
            this.tableData = [];
            this.currentPage = 1;
            this.getMemberList();
        },
        viewMore() {
            var currentPage = this.currentPage;
            if (currentPage < this.totalPages) {
                this.currentPage = currentPage + 1;
                this.getMemberList();
            } else {
                this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 18px;
}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    display: flex;
    align-items: center;
    margin-top: 118px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top: 18px;
}

.page-content-header {
    width: 100%;
    height: 80px;
    line-height: 80px;
    position: relative;
    display: flex;
    align-items: center;
}

.study-image {
    width: 22px;
    height: 22px;
    display: inline-block;
    margin-left: 7px;
    cursor: pointer;
    position: relative;
    top: 6px;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item-active {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
}

.page-study-header-item-active {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
    margin-left: 45px;
}

.study-image-wrapper {
    position: relative;
    top: 7px;
}

.page-card-wrapper {
    margin-left: 45px;
    padding-bottom: 40px;
}

.page-menmber-container {
    display: flex;
}

.page-menmber-wrapper {
    flex: 1;
    margin-left: 45px;
    margin-right: 45px;
}

.course-info-item {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-bottom: 10px;
}

.member-card-container {
    margin: 20px 0px 80px 0px;
}

.page-mode-input-wrapper {
    display: flex;
    width: 235px;
    position: relative;
    top: -5px;
    margin-top: 10px;
}

.page-mode-input>>>.el-input__inner {
    width: 160px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right: 0px !important;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

.card-container {
    width: 100%;
    display: flex;
    height: 168px;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px 0px rgba(149, 154, 170, 0.1);
    border-radius: 9px;
    border: 1px solid #F0F0F3;
}

.card-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.card-data {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #4F79ED;
    margin-top: 8px;
}

.card-image-wrapper {
    width: 52px;
    height: 52px;
    border: 2px solid #4F79ED;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 43px;
}

.card-img {
    width: 22px;
    height: 22px;
}

.popover-label {
    font-size: 14px;
    line-height: 25px;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 20px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}</style>


